import { Injectable, signal, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';

export interface SalesStat {
  salE_DT: string;
  paY_AMT: number;
  paY_CARD: number;
  paY_CASH: number;
  paY_OTHER: number;
}

export interface WeekRange {
  start: Date;
  end: Date;
}

export interface Notice {
  id: string;
  title: string;
  date: string;
}

export interface PopularItem {
  rank: number;
  servicE_CD: string;
  servicE_NM: string;
  totalcnt: number;
  totaL_SUM: number;
}

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  // FIX: Explicitly type `http` as HttpClient to resolve type inference issues where it was inferred as `unknown`.
  private http: HttpClient = inject(HttpClient);

  // getWeeklySalesStats() {
  //   return signal<SalesStat[]>([
  //     { date: '12/01', card: 500, cash: 300, other: 50 },
  //     { date: '12/02', card: 2800, cash: 1500, other: 200 },
  //     { date: '12/03', card: 1800, cash: 1600, other: 150 },
  //     { date: '12/04', card: 400, cash: 200, other: 20 },
  //     { date: '12/05', card: 300, cash: 100, other: 10 },
  //     { date: '12/06', card: 0, cash: 0, other: 0 },
  //     { date: '12/07', card: 0, cash: 0, other: 0 },
  //   ]);
  // }

  getStoreSummary() {
    return signal({
      storeName: 'PetAnimal Dongbaek',
      weeklyAvgSales: 999999999,
      yesterdaySales: 999999999,
      currentSales: 999999999,
    });
  }

  // getPopularServices() {
  //   return signal<PopularItem[]>([
  //     { rank: 1, name: 'Hygiene', count: 57 },
  //     { rank: 2, name: 'Hygiene+Beauty', count: 36 },
  //     { rank: 3, name: 'Full Beauty', count: 26 },
  //   ]);
  // }

  // getPopularOptions() {
  //   return signal<PopularItem[]>([
  //     { rank: 1, name: 'Spa', count: 42 },
  //     { rank: 2, name: 'Dye', count: 15 },
  //   ]);
  // }

  getReservationStats() {
    return signal({
      weeklyReservations: 999999,
      prevWeekReservations: 999111,
      reservationChange: 12,
      isReservationIncrease: true,
      weeklyCancellations: 999999,
      prevWeekCancellations: 999111,
      cancellationChange: 2,
      isCancellationIncrease: true,
    });
  }

  getNotices() {
    const notices = signal<Notice[]>([]);
    // Use HttpClient to fetch mock data, which will trigger the interceptor.
    // this.http.get<any[]>('https://jsonplaceholder.typicode.com/posts?_limit=5').pipe(
    //   // FIX: Explicitly typed `posts` to `any[]` to fix an issue where it was being inferred as `unknown`, causing a compile error on `posts.map`.
    //   tap((posts: any[]) => {
    //     const formattedNotices: Notice[] = posts.map((post: any, index: number) => ({
    //       id: post.id.toString(),
    //       title: this.capitalizeFirstLetter(post.title),
    //       date: `2025-01-0${5-index}`
    //     }));
    //     notices.set(formattedNotices);
    //   })
    // ).subscribe({
    //   error: (err) => console.error('Failed to fetch notices:', err)
    // });
    return notices;
  }

  private capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  getWeekByDate(date: Date): WeekRange {
    const day = date.getDay();

    const diffToMonday = (day === 0 ? -6 : 1 - day);

    const monday = new Date(date);
    monday.setDate(date.getDate() + diffToMonday);
    monday.setHours(0, 0, 0, 0);

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    sunday.setHours(23, 59, 59, 999);

    return {
      start: monday,
      end: sunday
    };
  }

  nextWeek(range: WeekRange): WeekRange {
    const next = new Date(range.start);
    next.setDate(next.getDate() + 7);
    return this.getWeekByDate(next);
  }

  prevWeek(range: WeekRange): WeekRange {
    const prev = new Date(range.start);
    prev.setDate(prev.getDate() - 7);
    return this.getWeekByDate(prev);
  }
}
